/**
 * `/scope/available` для экранов, которым нужен ЛОКАЛЬНЫЙ выбор области.
 *
 * Ключ общий с `fetchScopeAvailable` (`sharedQueryKeys.scopeAvailable`) —
 * значит селектор в шапке, карта и экран-потребитель делят один кэш и один
 * сетевой запрос. Отдельный ключ на экран (как было заведено в аналитике)
 * повторяет тот же ответ ещё раз; повторять это в новых экранах не надо.
 *
 * Хук НЕ переключает область сессии — он только читает список доступного.
 */
import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { sharedQueryKeys } from '@/lib/http/sharedQueries';
import type { AvailableScopes } from './ScopeTree';

export function useAvailableScopes(): UseQueryResult<AvailableScopes> {
  return useQuery({
    queryKey: sharedQueryKeys.scopeAvailable,
    queryFn: () => api.get<AvailableScopes>('/api/v1/scope/available'),
    staleTime: 5 * 60_000,
  });
}
